import API from "./API";
import { Booking, BookingFilters, BookingsResponse, BookingDetails } from "../../Types/Dashboard";

class BookingService extends API {
  static getBookings = (
    filters?: BookingFilters
  ): Promise<{ data: BookingsResponse }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());
    if (filters?.status) params.append("status", filters.status);
    if (filters?.tutor_id) params.append("tutor_id", filters.tutor_id.toString());
    if (filters?.student_id)
      params.append("student_id", filters.student_id.toString());
    if (filters?.start_date) params.append("start_date", filters.start_date);
    if (filters?.end_date) params.append("end_date", filters.end_date);

    const queryString = params.toString();
    return this.getRequest(
      `admin/bookings${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: BookingsResponse }>;
  };

  static getBookingDetails = (
    id: number
  ): Promise<{ data: { booking: BookingDetails } }> => {
    return this.getRequest(`admin/bookings/${id}`, true) as unknown as Promise<{ data: { booking: BookingDetails } }>;
  };
}

export default BookingService;
